import React from "react";
import { Card, CardColumns, Container, Button, Modal } from "react-bootstrap";
import CarouselCom from "./CarouselCom";
import BannerTitles from "./BannerTitles";

let animationArray = ["cardMoveInTop", "cardMoveInBottom", "cardMoveInLeft", "cardMoveInRight"];

let commercial = [
	{
		name: "25th Avenue, San Francisco, CA",
		images: ["25th Avenue, San Francisco, CA1.jpg-25th Avenue, San Francisco, CA2.jpg-25th Avenue, San Francisco, CA3.jpg-25th Avenue, San Francisco, CA4.jpg-25th Avenue, San Francisco, CA5.jpg-25th Avenue, San Francisco, CA6.jpg-25th Avenue, San Francisco, CA7.jpg-25th Avenue, San Francisco, CA9.jpg-25th Avenue, San Francisco, CA10.jpg"],
		source: "remodels"
	},
	{
		name: "Howard, Burlingame, CA",
		images: ["Howard, Burlingame, CA1.jpg-Howard, Burlingame, CA2.jpg-Howard, Burlingame, CA3.jpg-Howard, Burlingame, CA4.jpg-Howard, Burlingame, CA5.jpg-Howard, Burlingame, CA6.jpg"]
	},
	{
		name: "N. Lenore, Willits, CA (2 Buildings)",
		images: [
			"N. Lenore, Willits, CA (2 Buildings)1.jpg-N. Lenore, Willits, CA (2 Buildings)2.jpg-N. Lenore, Willits, CA (2 Buildings)3.jpg-N. Lenore, Willits, CA (2 Buildings)4.jpg-N. Lenore, Willits, CA (2 Buildings)5.jpg-N. Lenore, Willits, CA (2 Buildings)6.jpg-N. Lenore, Willits, CA (2 Buildings)7.jpg-N. Lenore, Willits, CA (2 Buildings)8.jpg-N. Lenore, Willits, CA (2 Buildings)9.jpg-N. Lenore, Willits, CA (2 Buildings)10.jpg-N. Lenore, Willits, CA (2 Buildings)11.jpg-N. Lenore, Willits, CA (2 Buildings)12.jpg-N. Lenore, Willits, CA (2 Buildings)13.jpg-N. Lenore, Willits, CA (2 Buildings)14.jpg-N. Lenore, Willits, CA (2 Buildings)15.jpg-N. Lenore, Willits, CA (2 Buildings)16.jpg"
		]
	},
	{
		name: "Post Street, San Francisco, CA",
		images: ["Post Street, San Francisco, CA1.jpg-Post Street, San Francisco, CA2.jpg-Post Street, San Francisco, CA3.jpg-Post Street, San Francisco, CA4.jpg-Post Street, San Francisco, CA5.jpg"]
	},
	{
		name: "San Mateo Ave San Bruno, CA",
		images: ["San Mateo Ave San Bruno, CA1.jpg-San Mateo Ave San Bruno, CA2.jpg-San Mateo Ave San Bruno, CA3.jpg"]
	}
];
let imgPath = require.context("../../public/images/commercial", true);
let remodelsImgPath = require.context("../../public/images/remodels", true);

const titleMap = {
	"25th Avenue, San Francisco, CA": "25th Avenue Building",
	"Howard, Burlingame, CA": "Howard Building",
	"N. Lenore, Willits, CA (2 Buildings)": "N. Lenore Building",
	"Post Street, San Francisco, CA": "Post Street Building",
	"San Mateo Ave San Bruno, CA": "San Mateo Avenue Building"
};

const locationMap = {
	"25th Avenue, San Francisco, CA": "San Francisco, CA",
	"Howard, Burlingame, CA": "Burlingame, CA",
	"N. Lenore, Willits, CA (2 Buildings)": "Willits, CA",
	"Post Street, San Francisco, CA": "San Francisco, CA",
	"San Mateo Ave San Bruno, CA": "San Bruno, CA"
};

const getLocation = name => locationMap[name] || name;
const getProjectTitle = name => titleMap[name] || name;

const Commercial = props => {
	return (
		<Container fluid className="p-0">
			<BannerTitles title={"Commercial & Industrial"} />
			<Container className="col-12 col-md-9">
				<CardColumns>
					{commercial.map((build, idx) => {
						let time = Math.random() * 4;
						let num = Math.floor(Math.random() * Math.floor(4));
						let name = animationArray[num];
						let imgStyle = { animation: `${name} ${time}s` };
						let imgSrc = build.source === "remodels" ? remodelsImgPath("./" + `${build.name}` + "1.jpg") : imgPath("./" + `${build.name}` + "1.jpg");

						return (
							<Card className="gallery-card" style={imgStyle} key={idx} value={build.name}>
								<Card.Img src={imgSrc}></Card.Img>
								<Card.ImgOverlay className="gallery-overlay">
									<Button onClick={props.handleClick} value={build.name} name={build.images} className="gallery-view-button">
										View
									</Button>
								</Card.ImgOverlay>
								<Card.Body>
									<Card.Title>{getProjectTitle(build.name)}</Card.Title>
									<Card.Text>Commercial & Industrial | {getLocation(build.name)}</Card.Text>
								</Card.Body>
							</Card>
						);
					})}

					<Modal show={props.show} onHide={props.closeModal} container={this} dialogClassName="modal-90w" aria-labelledby="contained-modal-title">
						<Modal.Header closeButton className="lightbox-header" />
						<Modal.Body className="mx-auto" style={{ width: "100%" }}>
							<CarouselCom images={props.imgs} />
						</Modal.Body>
					</Modal>
				</CardColumns>
				<hr className="my-5" />
			</Container>
		</Container>
	);
};

export default Commercial;
